import { render, staticRenderFns } from "./CommentHistoryModal.vue?vue&type=template&id=334b1dba&scoped=true"
import script from "./CommentHistoryModal.vue?vue&type=script&lang=js"
export * from "./CommentHistoryModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "334b1dba",
  null
  
)

export default component.exports